import React from "react";
import PropTypes from "prop-types";
import Button from "../../../common/Button";
import EditIcon from "../../../common/Icons/EditIcon";
import Options from "./Options";
import yourDesignHere from "../../../../mocks/your-design-here";

import styles from "./product.module.scss";

function Product({productName, title, preview, minPrice, editorPath, options}) {
  const yourDesignHereSrc = yourDesignHere[productName];
  return (
    <a href={editorPath} className={styles.root}>
      <div className={styles.preview}>
        <img loading="lazy" src={preview} alt={title} />
        {yourDesignHereSrc && (
          <img loading="lazy"
            src={yourDesignHereSrc}
            alt="Добавьте свой текст или рисунок"
            className={styles.yourDesignHere}
          />
        )}
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.price}>от {minPrice} ₽</div>
      <div className={styles.footer}>
        <div className={styles.options}>
          <Options options={options} />
        </div>
        <div className={styles.createPrint}>
          <Button
            variant="contained"
            size="medium"
            style="primary"
            className={styles.button}
          >
            <EditIcon />
            Создать принт
          </Button>
        </div>
      </div>
    </a>
  );
}

Product.propTypes = {
  productName: PropTypes.string,
  title: PropTypes.string,
  preview: PropTypes.string,
  minPrice: PropTypes.number,
  editorPath: PropTypes.string,
  options: PropTypes.array
};

export default Product;
